import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { FracasProvider } from './contexts/FracasContext';
import { EightDProvider } from './contexts/EightDContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <FracasProvider>
                    <EightDProvider>
                        <App />
                    </EightDProvider>
                </FracasProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);
